(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mf-american-leather-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-al-carousel')) {
    customElements.define('ms-al-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.ms-al-carousel__track');
        const previous = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const slide = track.querySelector('.ms-al-carousel__slide');
          if (!slide) return;
          const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-comfort-sleeper-collection"] && !Shopify.designMode) return;
  try {
    
  function initComfortSections() {
    document.querySelectorAll('[data-comfort-hub]').forEach(root => {
      if (!window.ModernDirectory) return;
      window.ModernDirectory.init(root, {prefix:'comfort', initial:false, collectionUrl:root.dataset.collectionUrl, total:Number(root.dataset.collectionTotal), sectionId:root.dataset.comfortSection, pageSize:250});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initComfortSections);
  else initComfortSections();
  document.addEventListener('shopify:section:load', initComfortSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-dovetail-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-dovetail-discovery')) {
    customElements.define('ms-dovetail-discovery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('.ms-dovetail__categories--slider');
        const previous = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (!track || !previous || !next) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const section = this.closest('.ms-dovetail--polished');
        const typeSearch = section?.querySelector('[data-type-search]');
        const typeLinks = [...(section?.querySelectorAll('[data-type-label]') || [])];
        const noTypes = section?.querySelector('[data-no-types]');
        if (typeSearch) {
          section.querySelector('[data-search-wrap]').hidden = false;
          const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
          typeSearch.addEventListener('input', () => {
            const query = normalize(typeSearch.value);
            let matches = 0;
            for (const link of typeLinks) {
              const matchesQuery = normalize(link.dataset.typeLabel).includes(query);
              link.hidden = !matchesQuery;
              if (matchesQuery) matches += 1;
            }
            if (noTypes) noTypes.hidden = matches > 0;
          }, options);
        }
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maximum - 2;
        };
        const move = direction => {
          const card = track.querySelector('.ms-dovetail__category-card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        this.setAttribute('data-ready', '');
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-eilersen-collection"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('click', (event) => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('.eilersen-page a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  history.replaceState(history.state, '', link.hash);
  target.scrollIntoView({block:'start', behavior:'instant'});
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-outdoor-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-outdoor-hub]').forEach(function(root){
  if(!root || root.dataset.outdoorCatsReady) return;
  root.dataset.outdoorCatsReady='1';
  var track=root.querySelector('[data-outdoor-cat-track]');
  if(!track) return;
  var prev=root.querySelector('[data-outdoor-cat-prev]');
  var next=root.querySelector('[data-outdoor-cat-next]');
  var arrows=function(){
    if(!prev||!next) return;
    prev.disabled=track.scrollLeft<2;
    next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
  };
  var slideStep=function(){
    var first=track.firstElementChild;
    if(!first) return track.clientWidth;
    return first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||14);
  };
  var slideBehavior=function(){
    return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
  };
  var move=function(dir){
    track.scrollTo({left:(Math.round(track.scrollLeft/slideStep())+dir)*slideStep(),behavior:slideBehavior()});
  };
  var drag=null;
  var suppressClickUntil=0;
  track.addEventListener('dragstart', function(e){ e.preventDefault(); });
  track.addEventListener('pointerdown', function(event){
    if(event.pointerType!=='mouse'||event.button!==0) return;
    drag={id:event.pointerId,x:event.clientX,left:track.scrollLeft,moved:false};
  });
  window.addEventListener('pointermove', function(event){
    if(!drag||event.pointerId!==drag.id) return;
    var distance=event.clientX-drag.x;
    if(!drag.moved&&Math.abs(distance)<7) return;
    if(!drag.moved){
      drag.moved=true;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    track.scrollLeft=drag.left-distance;
  }, {passive:false});
  var finishDrag=function(event){
    if(!drag||event.pointerId!==drag.id) return;
    if(drag.moved) suppressClickUntil=Date.now()+400;
    if(track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    track.classList.remove('is-dragging');
    if(drag.moved) track.scrollTo({left:Math.round(track.scrollLeft/slideStep())*slideStep(),behavior:slideBehavior()});
    drag=null;
  };
  window.addEventListener('pointerup', finishDrag);
  window.addEventListener('pointercancel', finishDrag);
  track.addEventListener('click', function(event){
    if(event.detail&&Date.now()<suppressClickUntil){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  if(prev) prev.addEventListener('click', function(){ move(-1); });
  if(next) next.addEventListener('click', function(){ move(1); });
  track.addEventListener('scroll', arrows, {passive:true});
  if(window.ResizeObserver) new ResizeObserver(arrows).observe(track);
  arrows();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-thomas-dawn-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.mstd__path, .ms-resin-links a');
  if (!link) return;
  const target = new URL(link.href, location.origin);
  if (target.searchParams.has('filter.p.product_type') || target.searchParams.has('filter.p.vendor')) {
    try { sessionStorage.removeItem('ms-collection-local-search:' + target.pathname); } catch (error) {}
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-al-sleeper-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-sleeper-editorial')) {
  customElements.define('ms-sleeper-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const opener = this.querySelector('.ms-sleeper-editorial__watch');
      const panel = this.querySelector('.ms-sleeper-editorial__film');
      const video = panel.querySelector('video');
      const closer = panel.querySelector('button');
      const close = () => {
        video.pause();
        panel.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        opener.focus();
      };
      opener.addEventListener('click', event => {
        event.preventDefault();
        panel.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        video.focus();
        video.play().catch(() => {});
      });
      closer.addEventListener('click', close);
      panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-bar-stools-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ms-stool-brands')){
customElements.define('ms-stool-brands',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.ms-stools__track');
this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
this.controller=new AbortController();const options={signal:this.controller.signal};
this.update=()=>{this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2};
const move=direction=>this.track.scrollBy({left:direction*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
this.prev.addEventListener('click',()=>move(-1),options);this.next.addEventListener('click',()=>move(1),options);
this.track.addEventListener('scroll',this.update,{...options,passive:true});
this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-bedroom-landing"] && !Shopify.designMode) return;
  try {
     function initBedroomBrands(scope) {   scope.querySelectorAll('[data-bedroom-brands]').forEach(function(root) {     if (root.dataset.ready) return;     root.dataset.ready = 'true';     var track = root.querySelector('.ms-bedroom-brands__track');     var prev = root.querySelector('[data-brand-prev]');     var next = root.querySelector('[data-brand-next]');     function update() { prev.disabled = track.scrollLeft <= 5; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3; }     function move(direction) { var card = track.querySelector('a'); var step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap); track.scrollBy({left:direction*step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }     prev.addEventListener('click', function(){ move(-1); });     next.addEventListener('click', function(){ move(1); });     track.addEventListener('scroll', update, {passive:true});     new ResizeObserver(update).observe(track);     update();   }); } initBedroomBrands(document); document.addEventListener('shopify:section:load', function(event){ initBedroomBrands(event.target); }); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-colibri-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-colibri-studio')) {
  customElements.define('ms-colibri-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const track=root.querySelector('[data-brand-track]');
      if (!track) return;
      const prev=root.querySelector('[data-brand-prev]'), next=root.querySelector('[data-brand-next]');
      const arrows=()=>{ if(!prev||!next) return; prev.disabled=track.scrollLeft<2; next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2; };
      const slideStep=()=>track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||14);
      const slideBehavior=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
      const move=dir=>track.scrollTo({left:(Math.round(track.scrollLeft/slideStep())+dir)*slideStep(),behavior:slideBehavior()});
      let drag = null;
      let suppressClickUntil = 0;
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id:event.pointerId, x:event.clientX, left:track.scrollLeft, moved:false };
      });
      window.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 7) return;
        if (!drag.moved) {
          drag.moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      }, { passive:false });
      const finishDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) suppressClickUntil = Date.now() + 400;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        if(drag.moved)track.scrollTo({left:Math.round(track.scrollLeft/slideStep())*slideStep(),behavior:slideBehavior()});
        drag = null;
      };
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      track.addEventListener('click', event => {
        if (event.detail && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      if(prev) prev.addEventListener('click',()=>move(-1));
      if(next) next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',arrows,{passive:true});
      new ResizeObserver(arrows).observe(track);
      arrows();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-custom-upholstery-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-project-gallery')) {
  customElements.define('ms-project-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const slides = Array.from(this.querySelectorAll('[data-project]'));
      const thumbs = Array.from(this.querySelectorAll('[data-select]'));
      if (!slides.length) return;
      const dialog = this.querySelector('dialog');
      const counter = this.querySelector('[data-counter]');
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        thumbs[index]?.scrollIntoView({behavior:'instant', block:'nearest', inline:'nearest'});
      };
      this.querySelector('.mscu-projects__controls').hidden = slides.length < 2;
      this.querySelector('.mscu-projects__thumbs').hidden = slides.length < 2;
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      this.querySelector('[data-prev]').addEventListener('click', () => show(index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => show(index + 1));
      this.querySelector('.mscu-projects__thumbs').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
        thumbs[index].focus({preventScroll:true});
      });
      let touchStart = null;
      const stage = this.querySelector('.mscu-projects__slides');
      stage.addEventListener('touchstart', event => { touchStart = [event.touches[0].clientX,event.touches[0].clientY]; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!touchStart) return;
        const dx = event.changedTouches[0].clientX - touchStart[0];
        const dy = event.changedTouches[0].clientY - touchStart[1];
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
        touchStart = null;
      }, {passive:true});
      let returnFocus;
      slides.forEach(slide => slide.querySelector('a').addEventListener('click', event => {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        returnFocus = event.currentTarget;
        dialog.querySelector('img').src = returnFocus.href;
        dialog.showModal();
      }));
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => returnFocus?.focus({preventScroll:true}));
      slides.forEach((slide, i) => { slide.hidden = i !== 0; });
      thumbs[0]?.setAttribute('aria-pressed','true');
      counter.textContent = `01 / ${String(slides.length).padStart(2, '0')}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-design-your-recline"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const root = document.querySelector(':is(#recline-styles,#air-styles,#echo-styles) [data-dyr-browse]');
    if (!root || root.dataset.dyrReady) return;
    const findQuery = () => document.querySelector('#CollectionAjaxContent input[data-local-query]');
    const findSort = () => document.querySelector('#CollectionAjaxContent #SortBy');
    if (!findQuery() || !findSort()) return;
    root.dataset.dyrReady = 'true';
    root.hidden = false;
    const proxySort = root.querySelector('[data-dyr-sort]');
    const sync = () => {
      const term = (findQuery()?.value || '').trim().toLowerCase();
      root.querySelectorAll('[data-dyr-style]').forEach(button => {
        const active = button.dataset.dyrStyle.toLowerCase() === term;
        button.setAttribute('aria-pressed', String(active));
      });
      const nativeSort = findSort();
      if (nativeSort && [...proxySort.options].some(option => option.value === nativeSort.value)) proxySort.value = nativeSort.value;
    };
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-dyr-style]');
      if (!button) return;
      const query = findQuery();
      if (!query) return;
      query.value = button.dataset.dyrStyle;
      query.dispatchEvent(new Event('input', {bubbles:true}));
      sync();
    });
    proxySort.addEventListener('change', () => {
      const nativeSort = findSort();
      if (!nativeSort) return;
      nativeSort.value = proxySort.value;
      nativeSort.dispatchEvent(new Event('change', {bubbles:true}));
    });
    document.addEventListener('input', event => {
      if (event.target.matches('#CollectionAjaxContent input[data-local-query]')) sync();
    });
    document.addEventListener('change', event => {
      if (event.target.matches('#CollectionAjaxContent #SortBy')) sync();
    });
    const content = document.getElementById('MainContent');
    if (content) new MutationObserver(sync).observe(content, {childList:true,subtree:true});
    sync();
  };
  const startup = new MutationObserver(() => {
    init();
    if (document.querySelector(':is(#recline-styles,#air-styles,#echo-styles) [data-dyr-browse]')?.dataset.dyrReady) startup.disconnect();
  });
  if (document.querySelector(':is(#recline-styles,#air-styles,#echo-styles) [data-dyr-browse]')) startup.observe(document.documentElement, {childList:true,subtree:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-dining-chair-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-chair-brands')) {
  customElements.define('ms-chair-brands', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      const track = this.querySelector('.ms-chair-brands__track');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (!track || !prev || !next) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const update = () => {
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, {...options, passive: true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-dining-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-dining-studio')) {
  customElements.define('ms-dining-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const track=root.querySelector('[data-brand-track]');
      const prev=root.querySelector('[data-brand-prev]'),next=root.querySelector('[data-brand-next]');
      const arrows=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
      const slideStep=()=>track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
      const slideBehavior=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
      const move=dir=>track.scrollTo({left:(Math.round(track.scrollLeft/slideStep())+dir)*slideStep(),behavior:slideBehavior()});
      let drag = null;
      let suppressClickUntil = 0;
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id:event.pointerId, x:event.clientX, left:track.scrollLeft, moved:false };
      });
      window.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 7) return;
        if (!drag.moved) {
          drag.moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      }, { passive:false });
      const finishDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) suppressClickUntil = Date.now() + 400;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        if(drag.moved)track.scrollTo({left:Math.round(track.scrollLeft/slideStep())*slideStep(),behavior:slideBehavior()});
        drag = null;
      };
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      track.addEventListener('click', event => {
        if (event.detail && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',arrows,{passive:true});new ResizeObserver(arrows).observe(track);arrows();

    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-dynamic-brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const rail = root.querySelector('.ms-brand-directory__visual-grid');
      const advanced = root.querySelector('[data-brand-advanced]');
      if (advanced) advanced.open = !window.matchMedia('(max-width:639px)').matches;
      if (rail) {
        const buttons = [...root.querySelectorAll('[data-brand-rail]')];
        const updateRail = () => buttons.forEach(button => {
          button.disabled = Number(button.dataset.brandRail) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        });
        buttons.forEach(button => button.addEventListener('click', () => rail.scrollBy({left:Number(button.dataset.brandRail) * (rail.clientWidth * .8), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'})));
        rail.addEventListener('scroll', updateRail, {passive:true});
        if ('ResizeObserver' in window) { const observer = new ResizeObserver(updateRail); observer.observe(rail); root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true}); }
        updateRail();
      }
      const words = value => window.ModernDirectory?.words ? window.ModernDirectory.words(value) : String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().match(/[a-z0-9]+/g) || [];

      const search = root.querySelector('[data-ms-brand-search]');
      const items = [...root.querySelectorAll('[data-ms-brand-item]')];
      const groups = [...root.querySelectorAll('[data-ms-brand-group]')];
      const count = root.querySelector('[data-ms-brand-count]');
      const empty = root.querySelector('[data-ms-brand-empty]');
      const resets = [...root.querySelectorAll('[data-ms-brand-reset]')];
      const letterLinks = [...root.querySelectorAll('[data-ms-brand-letter]')];
      const filterButtons = [...root.querySelectorAll('[data-ms-brand-filter]')];
      const originSelect = root.querySelector('[data-ms-brand-origin]');
      const specialtySelect = root.querySelector('[data-ms-brand-specialty]');
      const specialtyShortcuts = root.querySelector('[data-ms-specialty-shortcuts]');
      const revealTargets = [...root.querySelectorAll('[data-ms-reveal]')];
      let activeFilter = 'all';

      const origins = new Map();
      items.forEach((item) => {
        const value = item.dataset.brandCountry;
        const label = item.dataset.brandCountryLabel;
        if (value && label) origins.set(value, label);
      });
      [...origins.entries()]
        .sort((a, b) => a[1].localeCompare(b[1]))
        .forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          originSelect.append(option);
        });

      const specialties = new Map();
      items.forEach((item) => {
        const value = item.dataset.brandSpecialty;
        const label = item.dataset.brandSpecialtyLabel;
        if (value && label) specialties.set(value, label);
      });
      [...specialties.entries()]
        .sort((a, b) => a[1].localeCompare(b[1]))
        .forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          specialtySelect.append(option);

          const shortcut = document.createElement('button');
          shortcut.type = 'button';
          shortcut.textContent = label;
          shortcut.addEventListener('click', () => {
            specialtySelect.value = value;
            filter();
            root.querySelector('.ms-brand-directory__tools').scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          specialtyShortcuts?.append(shortcut);
        });

      const setActiveLetter = (letter) => {
        letterLinks.forEach((link) => {
          const active = link.dataset.msBrandLetter === letter && !link.classList.contains('is-unavailable');
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      const updateCount = (visible) => {
        const singular = root.dataset.countSingular || 'brand';
        const plural = root.dataset.countPlural || 'brands';
        count.textContent = `${visible} ${visible === 1 ? singular : plural}`;
      };

      const filter = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const activeOrigin = originSelect.value;
        const activeSpecialty = specialtySelect.value;
        const hasActiveCriteria = Boolean(query) || activeFilter !== 'all' || activeOrigin !== 'all' || activeSpecialty !== 'all';
        let visible = 0;

        root.classList.toggle('has-active-filters', hasActiveCriteria);
        const clearControl = root.querySelector('.ms-brand-directory__clear');
        if (clearControl) clearControl.hidden = !hasActiveCriteria;

        items.forEach((item) => {
          const matchesQuery = !query || words(query).every(term => words(item.dataset.brandName).some(word => word.startsWith(term)));
          let matchesFilter = true;

          if (activeFilter === 'featured') matchesFilter = item.dataset.brandFeatured === 'true';
          if (activeFilter === 'swatches') matchesFilter = item.dataset.brandSwatches === 'true';

          const matchesOrigin = activeOrigin === 'all' || item.dataset.brandCountry === activeOrigin;
          const matchesSpecialty = activeSpecialty === 'all' || item.dataset.brandSpecialty === activeSpecialty;
          const show = matchesQuery && matchesFilter && matchesOrigin && matchesSpecialty;
          item.hidden = !show;
          item.classList.toggle('is-match', show && hasActiveCriteria);
          if (show) visible += 1;
        });

        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-ms-brand-item]:not([hidden])');
        });

        const visibleLetters = new Set(groups.filter((group) => !group.hidden).map((group) => group.dataset.msBrandGroup));
        letterLinks.forEach((link) => {
          const available = visibleLetters.has(link.dataset.msBrandLetter);
          link.classList.toggle('is-unavailable', !available);
          if (available) {
            link.removeAttribute('aria-disabled');
            link.removeAttribute('tabindex');
          } else {
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('tabindex', '-1');
          }
        });

        empty.hidden = visible !== 0;
        updateCount(visible);
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.msBrandFilter;
          filterButtons.forEach((filterButton) => {
            filterButton.setAttribute('aria-pressed', String(filterButton === button));
          });
          filter();
        });
      });

      search.addEventListener('input', filter);
      search.addEventListener('search', filter);
      search.addEventListener('keydown', event => { if(event.key === 'Escape') {event.preventDefault();search.value='';filter();} });
      originSelect.addEventListener('change', filter);
      specialtySelect.addEventListener('change', filter);
      resets.forEach(reset => reset.addEventListener('click', () => {
        search.value = '';
        originSelect.value = 'all';
        specialtySelect.value = 'all';
        activeFilter = 'all';
        filterButtons.forEach((filterButton) => {
          filterButton.setAttribute('aria-pressed', String(filterButton.dataset.msBrandFilter === 'all'));
        });
        filter();
        search.focus();
      }));

      filter();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if ('IntersectionObserver' in window && !reduceMotion) {
        root.classList.add('is-reveal-ready');
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

        revealTargets.forEach((target) => revealObserver.observe(target));

        const letterObserver = new IntersectionObserver((entries) => {
          const activeEntry = entries
            .filter((entry) => entry.isIntersecting && !entry.target.hidden)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

          if (activeEntry) setActiveLetter(activeEntry.target.dataset.msBrandGroup);
        }, { rootMargin: '-22% 0px -66% 0px', threshold: 0 });

        groups.forEach((group) => letterObserver.observe(group));
      } else {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      }
    };

    document.querySelectorAll('[data-ms-brand-directory]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-ms-brand-directory]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-harbour-outdoor-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-harbour-carousel')) {
    customElements.define('ms-harbour-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.ms-harbour-carousel__track');
        const previous = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        const update = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const slide = track.querySelector('.ms-harbour-carousel__slide');
          if (!slide) return;
          const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-home-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-home-categories]').forEach((root) => {
      if (root.dataset.initialized) return;
      const track = root.querySelector('[data-category-track]');
      const cards = Array.from(track.querySelectorAll('.ms-home-category'));
      const previous = root.querySelector('[data-category-prev]');
      const next = root.querySelector('[data-category-next]');
      const status = root.querySelector('[data-category-status]');
      const mobile = window.matchMedia('(max-width: 749px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (cards.length < 2) return;
      root.dataset.initialized = 'true';
      root.querySelector('[data-category-controls]').hidden = false;
      root.querySelector('[data-category-footer]').hidden = false;
      let index = 0;
      let targetIndex = 0;
      let moving = false;
      let timer;
      const positions = () => cards.map(card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft);
      const refresh = () => {
        if (!mobile.matches) { track.removeAttribute('tabindex'); return; }
        track.tabIndex = 0;
        const max = track.scrollWidth - track.clientWidth;
        const offsets = positions();
        index = track.scrollLeft >= max - 2 ? cards.length - 1 : offsets.reduce((best, offset, i) => Math.abs(offset - track.scrollLeft) < Math.abs(offsets[best] - track.scrollLeft) ? i : best, 0);
        previous.setAttribute('aria-disabled', String(index === 0));
        next.setAttribute('aria-disabled', String(index === cards.length - 1));
        root.querySelector('[data-category-count]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        root.querySelector('[data-category-progress]').style.width = `${(index + 1) / cards.length * 100}%`;
        const message = status.dataset.label.replace('__CURRENT__', index + 1).replace('__TOTAL__', cards.length) + ': ' + cards[index].querySelector('h3').textContent;
        if (status.textContent !== message) status.textContent = message;
      };
      const move = (direction) => {
        if (!mobile.matches) return;
        targetIndex = Math.max(0, Math.min(cards.length - 1, (moving ? targetIndex : index) + direction));
        moving = true;
        track.scrollTo({left: Math.min(positions()[targetIndex], track.scrollWidth - track.clientWidth), behavior: reduced.matches ? 'instant' : 'smooth'});
        clearTimeout(timer);
        timer = setTimeout(() => { moving = false; refresh(); }, 450);
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => { moving = false; refresh(); }, 130);
      }, {passive: true});
      track.addEventListener('pointerdown', () => { moving = false; }, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !mobile.matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(refresh).observe(track);
      mobile.addEventListener('change', refresh);
      refresh();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-home-image-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button=event.target.closest('.ms-launch-hero__motion');
  if(!button) return;
  var hero=button.closest('.ms-launch-hero');
  var paused=hero.dataset.paused!=='true';
  hero.dataset.paused=String(paused);
  button.setAttribute('aria-pressed',String(paused));
  button.textContent=paused?button.dataset.playLabel:button.dataset.pauseLabel;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-kube-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-kube-studio')) {
  customElements.define('ms-kube-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this;
      const track=root.querySelector('[data-brand-track]');
      if (!track) return;
      const prev=root.querySelector('[data-brand-prev]'), next=root.querySelector('[data-brand-next]');
      const arrows=()=>{ if(!prev||!next) return; prev.disabled=track.scrollLeft<2; next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2; };
      const slideStep=()=>track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||14);
      const slideBehavior=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
      const move=dir=>track.scrollTo({left:(Math.round(track.scrollLeft/slideStep())+dir)*slideStep(),behavior:slideBehavior()});
      let drag = null;
      let suppressClickUntil = 0;
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id:event.pointerId, x:event.clientX, left:track.scrollLeft, moved:false };
      });
      window.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 7) return;
        if (!drag.moved) {
          drag.moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        track.scrollLeft = drag.left - distance;
      }, { passive:false });
      const finishDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) suppressClickUntil = Date.now() + 400;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        if(drag.moved)track.scrollTo({left:Math.round(track.scrollLeft/slideStep())*slideStep(),behavior:slideBehavior()});
        drag = null;
      };
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      track.addEventListener('click', event => {
        if (event.detail && Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      if(prev) prev.addEventListener('click',()=>move(-1));
      if(next) next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',arrows,{passive:true});
      new ResizeObserver(arrows).observe(track);
      arrows();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-material-library"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ms-material-library')) customElements.define('ms-material-library', class extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.sources = JSON.parse(this.querySelector('[data-sources]').textContent);
    this.normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
    this.performanceMap = new Map(Object.entries(JSON.parse(this.querySelector('[data-performance]').textContent)).map(([name, brand]) => [this.normalize(name), brand]));
    this.form = this.querySelector('form'); this.grid = this.querySelector('[data-results]'); this.status = this.querySelector('[data-status]'); this.more = this.querySelector('[data-more]'); this.retry = this.querySelector('[data-retry]'); this.shown = this.querySelector('[data-shown]');
    this.items = []; this.failed = []; this.limit = 30; this.complete = false;
    this.form.addEventListener('submit', event => event.preventDefault());
    this.form.addEventListener('input', () => { this.limit = 30; this.render(); });
    this.form.addEventListener('change', () => { this.limit = 30; this.render(); });
    this.form.addEventListener('reset', () => { requestAnimationFrame(() => { this.limit = 30; this.render(); }); });
    this.more.addEventListener('click', () => { this.limit += 30; this.render(); });
    this.retry.addEventListener('click', () => this.load());
    this.load();
  }
  material(item, source) {
    const title = this.normalize(item.title), tags = item.tags.map(this.normalize);
    const kind = tags.find(tag => /(?:kind|material):/.test(tag)) || '';
    const text = title + ' ' + kind;
    if (/leatherette|faux leather|\bppm\b|polyurethane/.test(text)) return 'Faux leather / PPM';
    if (/bonded leather/.test(text)) return 'Bonded leather';
    if (/nubuck/.test(text)) return 'Nubuck';
    if (/leather/.test(text) || tags.includes('leather')) return 'Leather';
    if (/\bwood\b|birch finish|walnut finish|oak finish|ash finish/.test(text) || tags.includes('wood')) return 'Wood finishes';
    if (/\bmetal\b/.test(text)) return 'Metal finishes';
    if (/fabric|textile/.test(kind) || tags.some(tag => /^(fabric|upholstery fabric|fabric and textiles)$/.test(tag))) return 'Fabric';
    return source.defaultMaterial || 'Other materials';
  }
  colors(item) {
    const tags = item.tags.map(this.normalize);
    const explicit = tags.filter(tag => /^(?:(?:td|al|huppe|soho|himolla) )?colou?r(?: family)?:/.test(tag)).map(tag => tag.replace(/^[^:]+:\s*/, ''));
    const simple = tags.filter(tag => /^(white|cream|ivory|beige|tan|brown|gray|grey|black|blue|green|red|pink|yellow|gold|orange|rust|purple|multicolou?r)$/.test(tag));
    const text = explicit.concat(simple).join(' ');
    const groups = [['White & cream', /white|cream|ivory/],['Beige & tan', /beige|\btan\b/],['Brown', /brown/],['Gray', /gray|grey/],['Black', /black/],['Blue', /blue/],['Green', /green/],['Red & pink', /red|pink|rose/],['Yellow & gold', /yellow|gold/],['Orange & rust', /orange|rust/],['Purple', /purple|violet/],['Multicolor', /multi/]];
    const values = groups.filter(([, pattern]) => pattern.test(text)).map(([name]) => name);
    return values.length ? values : ['Not specified'];
  }
  prepare(item, source) {
    const normalized = this.normalize(item.title).replace(/^(?:leather )?grade\s+[a-z0-9]+\s*:\s*/i, '');
    let performance = '';
    if (source.handle === 'american-leather-swatches') performance = this.performanceMap.get(normalized) || '';
    if (source.handle === 'thomas-dawn-swatches' && /^performance\s*:/i.test(item.title)) performance = 'Performance';
    if (source.handle === 'huppe-swatches' && item.tags.includes('Performance +')) performance = 'Performance';
    const material = this.material(item, source), colors = this.colors(item);
    return {...item, source:source.handle, supplier:source.name, material, colors, performance, search:this.normalize([item.title, source.name, material, colors.join(' '), performance, ...item.tags].join(' '))};
  }
  async load() {
    if (this.loading) return;
    this.loading = true; this.complete = false; this.failed = []; this.items = []; this.retry.hidden = true; this.grid.setAttribute('aria-busy', 'true'); this.status.textContent = 'Loading all supplier samples…';
    const results = new Map(); let completed = 0;
    const queue = [...this.sources];
    const run = async () => {
      while (queue.length) {
        const source = queue.shift();
        try {
          const get = async page => {
            const url = new URL(source.url, location.origin); url.searchParams.set('view', 'ms-material-index'); url.searchParams.set('page', page); url.searchParams.set('sort_by', 'title-ascending');
            const preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview);
            const response = await fetch(url, {signal:AbortSignal.timeout(25000)}); if (!response.ok) throw new Error('Sample index unavailable');
            const data = JSON.parse(await response.text()); if (!Array.isArray(data.products) || data.page !== page || data.pages > 100 || data.total > 25000) throw new Error('Invalid sample index');
            return data;
          };
          const first = await get(1); const items = [...first.products];
          for (let page = 2; page <= first.pages; page++) { const next = await get(page); if (next.total !== first.total) throw new Error('Collection changed'); items.push(...next.products); }
          if (items.length !== first.total || new Set(items.map(item => item.id)).size !== items.length) throw new Error('Incomplete sample index');
          results.set(source.handle, items.map(item => this.prepare(item, source)));
        } catch (error) { this.failed.push(source.name); }
        completed++; this.status.textContent = 'Loading samples: ' + completed + ' of ' + this.sources.length + ' suppliers checked…';
      }
    };
    await Promise.all(Array.from({length:Math.min(3, queue.length)}, run));
    if (!this.isConnected) { this.loading = false; return; }
    const seen = new Set(), lists = this.sources.map(source => results.get(source.handle) || []);
    const longest = Math.max(0, ...lists.map(list => list.length));
    for (let index = 0; index < longest; index++) for (const list of lists) { const item = list[index]; if (item && !seen.has(item.id)) { seen.add(item.id); this.items.push(item); } }
    this.populate('material', [...new Set(this.items.map(item => item.material))].sort());
    this.populate('color', [...new Set(this.items.flatMap(item => item.colors))].sort((a,b) => a === 'Not specified' ? 1 : b === 'Not specified' ? -1 : a.localeCompare(b)));
    this.loading = false; this.complete = true; this.retry.hidden = !this.failed.length; this.grid.setAttribute('aria-busy', 'false'); this.render();
  }
  populate(name, values) {
    const select = this.form.elements[name], selected = select.value;
    while (select.options.length > 1) select.remove(1);
    values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; select.appendChild(option); }); select.value = values.includes(selected) ? selected : '';
  }
  render() {
    if (!this.complete) return;
    const fields = this.form.elements, query = this.normalize(fields.query.value), supplier = fields.supplier.value, material = fields.material.value, color = fields.color.value, performance = fields.performance.checked;
    const terms = query.split(' ').filter(Boolean);
    const matches = this.items.filter(item => (!supplier || item.source === supplier) && (!material || item.material === material) && (!color || item.colors.includes(color)) && (!performance || item.performance) && terms.every(term => item.search.includes(term)));
    const fragment = document.createDocumentFragment();
    matches.slice(0, this.limit).forEach(item => {
      const link = document.createElement('a'); link.className = 'ml-sample'; link.href = item.url; link.dataset.sampleId = item.id;
      const imageBox = document.createElement('div'); imageBox.className = 'ml-sample-image';
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 440; img.height = 440; imageBox.appendChild(img); }
      link.appendChild(imageBox);
      const append = (tag, className, text) => { const element = document.createElement(tag); element.className = className; element.textContent = text; link.appendChild(element); };
      append('p','ml-sample-vendor',item.supplier); append('h3','',item.title); append('p','ml-sample-info',item.material); append('p','ml-sample-price',item.price);
      if (item.performance) append('span','ml-sample-badge',item.performance === 'Performance' ? 'Performance' : 'Performance · ' + item.performance);
      append('span','ml-sample-action',item.available ? 'View sample →' : 'Check availability →'); fragment.appendChild(link);
    });
    if (!matches.length) { const empty = document.createElement('p'); empty.className = 'ml-empty'; empty.textContent = this.failed.length ? 'Some supplier samples could not load. Retry loading or browse the supplier collections above.' : 'No samples match these filters. Try a broader search or clear your filters.'; fragment.appendChild(empty); }
    this.grid.replaceChildren(fragment);
    this.status.textContent = matches.length.toLocaleString() + ' matching samples' + (this.failed.length ? ' · Incomplete library: ' + this.failed.join(', ') + ' could not load.' : ' · ' + (supplier ? this.sources.find(source => source.handle === supplier).name : this.sources.length + ' suppliers'));
    this.shown.textContent = matches.length ? 'Showing ' + Math.min(this.limit,matches.length) + ' of ' + matches.length.toLocaleString() : '';
    this.more.hidden = this.limit >= matches.length;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-meet-the-brands"] && !Shopify.designMode) return;
  try {
    
function initMeetBrands(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const input=root.querySelector('[data-story-search]'),clear=root.querySelector('[data-story-clear]'),cards=[...root.querySelectorAll('[data-story-card]')],status=root.querySelector('[data-story-status]'),empty=root.querySelector('[data-story-empty]');
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  function filter(){const query=normalize(input.value.trim());let count=0;cards.forEach(card=>{const match=normalize(card.dataset.storyTerms).includes(query);card.hidden=!match;if(match)count++;});clear.hidden=!query;empty.hidden=count!==0;status.textContent=count+' '+(count===1?status.dataset.storySingular:status.dataset.storyLabel);}
  input.addEventListener('input',filter);clear.addEventListener('click',()=>{input.value='';filter();input.focus();});filter();
}
document.querySelectorAll('.ms-meet').forEach(initMeetBrands);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ms-meet').forEach(initMeetBrands));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-neavio-pilot"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.getElementById('nv-pilot');if(!root||root.dataset.ready)return;root.dataset.ready='true';const data=JSON.parse(root.querySelector('#nv-data').textContent),q=s=>root.querySelector(s),customBody='Custom Color (Contact Us)',t=data.text;
Object.keys(data.labels).forEach(k=>{data.labels[k]=data.labels[k].replaceAll('&amp;','&');});
const felts=['Brite White','Titanium','Steel Gray','Taupe','Khaki','Camel','Charcoal','Black','Brown','Navy','Euro Blue','Academy Blue','Brite Blue','Championship Green','Dark Green','Olive','Brite Lime','Burgundy','Wine','Brick Red','Red','Brite Pink','Purple','Brite Orange','Brite Gold','Aztec Gold','Yellow'];
// Concept specifications preserve the original design boards. Empty supplier felt means no exact named match.
// key, image label, native body, verified felt, sheen, approval, requested body, accent/base, concept cloth
const specs=[
['crisp_white','Crisp White','White','Brite White','Semi-Gloss',false,'White','White','White — Brite White supplier reference'],
['soft_ivory','Soft Ivory',customBody,'','Semi-Gloss',true,'Ivory','Ivory','Ivory'],
['warm_greige','Warm Greige',customBody,'','Satin (Natural)',true,'Greige','Greige','Greige'],
['stone_gray','Stone Gray',customBody,'','Semi-Gloss',true,'Stone gray','Stone gray','Stone gray'],
['graphite','Graphite',customBody,'Charcoal','Satin (Natural)',true,'Charcoal / Graphite','Charcoal / Graphite','Charcoal'],
['all_black','All Black',customBody,'Black','Piano Finish (High-Gloss)',true,'Black','Black','Black'],
['warm_neutral','Warm Neutral',customBody,'Taupe','Satin (Natural)',true,'Ivory','Champagne','Taupe'],
['camel_black','Camel & Black',customBody,'Camel','Matte',true,'Matte black','Bronze','Camel'],
['slate_ivory','Slate & Ivory',customBody,'','Semi-Gloss',true,'Ivory','Pale oak','Slate blue'],
['olive_charcoal','Olive & Charcoal',customBody,'Olive','Matte',true,'Charcoal','Walnut','Olive'],
['oxblood_black','Oxblood & Black',customBody,'','Matte',true,'Matte black','Dark bronze','Oxblood'],
['midnight','Midnight',customBody,'Navy','Satin (Natural)',true,'Graphite','Brushed steel','Navy'],
['cobalt_white','Cobalt & White',customBody,'Charcoal','Piano Finish (High-Gloss)',true,'Gloss white','Cobalt blue','Charcoal'],
['arctic_blue','Arctic Blue',customBody,'','Piano Finish (High-Gloss)',true,'Gloss white','Cobalt blue','Cobalt blue'],
['electric_blue','Electric Blue',customBody,'','Satin (Natural)',true,'Satin black','Electric blue','Electric blue'],
['cobalt_solid','Cobalt (Solid)',customBody,'','Semi-Gloss',true,'Cobalt','Cobalt','Cobalt'],
['emerald','Emerald',customBody,'','Satin (Natural)',true,'Satin black','Emerald green','Emerald green'],
['emerald_solid','Emerald (Solid)',customBody,'','Semi-Gloss',true,'Emerald','Emerald','Emerald'],
['racing_red','Racing Red',customBody,'','Satin (Natural)',true,'Satin black','Racing red','Racing red'],
['racing_red_solid','Racing Red (Solid)',customBody,'','Semi-Gloss',true,'Racing red','Racing red','Racing red'],
['tangerine','Tangerine',customBody,'','Satin (Natural)',true,'Satin black','Tangerine','Tangerine']];
const state={look:null,custom:false};const hero=q('#nv-hero'),original={src:hero.src,alt:hero.alt,srcset:hero.srcset};const sampleUrl=name=>'https://cdn.shopify.com/s/files/1/0266/7033/4031/files/wb-felt-'+(name==='Brite White'?'brite-white-bordered':name.toLowerCase().replaceAll(' ','-'))+'.jpg';
function photo(src,alt){hero.removeAttribute('srcset');hero.src=src;hero.alt=alt;}
function render(){const size=q('#nv-size').value,body=q('#nv-body').value,finish=q('#nv-finish').value,felt=q('#nv-felt').value,bodyDetail=q('#nv-body-detail').value,accent=q('#nv-accent').value;const chosen=state.custom||state.look;const customRequired=body===customBody||!!bodyDetail&&bodyDetail!==body||!!accent&&accent!==body||finish==='Piano Finish (High-Gloss)'||(!state.custom&&state.look?.[5]);const variant=data.variants.find(v=>v.options[0]===size&&v.options[1]===body&&v.options[2]===finish);q('#nv-look-field').disabled=!size;q('#nv-dim').textContent=size?({'7ft':'92″ × 53″ × 32″','8ft':'102″ × 58″ × 32″','9ft':'114″ × 64″ × 32″'}[size]):'';q('#nv-concept-cloth').textContent=state.look?.[8]||'—';q('#nv-felt-name').textContent=felt||t.choose;q('#nv-felt-sample').hidden=!felt;if(felt){q('#nv-felt-sample').src=sampleUrl(felt);q('#nv-felt-sample').alt=felt;}root.querySelectorAll('[data-felt]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.felt===felt)));root.querySelectorAll('[data-look]').forEach(b=>b.setAttribute('aria-pressed',String(!state.custom&&state.look?.[0]===b.dataset.look)));q('#nv-summary').textContent=chosen?[size,state.custom?t.custom:data.labels[state.look[0]],q('label[for="nv-body-detail"]').textContent+': '+(bodyDetail||body),q('label[for="nv-accent"]').textContent+': '+accent,finish,state.look?q('#nv-concept-label').textContent+': '+state.look[8]:'',q('label[for="nv-felt"]').textContent+': '+(felt||q('#nv-felt option').textContent)].filter(Boolean).join('\n'):t.choose;q('#nv-price').textContent=!size||!chosen?'':customRequired||!variant?t.quote:!felt?'':t.reference+' '+new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency}).format(variant.price/100);q('#nv-status').textContent=customRequired?t.concept:t.review;root.dataset.configuration=JSON.stringify({size,look:state.custom?'custom':state.look?.[0]||null,body,bodyDetail,accent,finish,felt,requestedFelt:state.look?.[8]||null,variantId:chosen&&!customRequired&&felt&&variant?variant.id:null,requiresApproval:customRequired,draft:true});syncCart({size,body,bodyDetail,accent,finish,felt,variant,customRequired,chosen});}
specs.forEach((s,i)=>{const b=document.createElement('button');b.type='button';b.className='nv-look';b.dataset.look=s[0];b.setAttribute('aria-pressed','false');const media=data.images.find(x=>x.alt?.replaceAll('&amp;','&')==='Neavio color scheme: '+s[1]);if(media){const im=document.createElement('img');im.src=media.src;im.alt=data.labels[s[0]];im.width=240;im.height=240;im.loading='lazy';b.append(im);}const name=document.createElement('strong');name.textContent=data.labels[s[0]];const sub=document.createElement('small');sub.textContent=(s[3]||s[8])+(s[5]?' · '+t.quote:'');b.append(name,sub);b.addEventListener('click',()=>{state.look=s;state.custom=false;q('#nv-body').value=s[2];q('#nv-body-detail').value=s[6];q('#nv-accent').value=s[7];q('#nv-finish').value=s[4];q('#nv-felt').value=s[3];q('#nv-notes').value=s[5]?s[1]+': '+s[6]+' / '+s[7]:'';if(media)photo(media.src,data.labels[s[0]]);q('#nv-caption').textContent=t.preset+' '+data.labels[s[0]];if(!s[3]){q('#nv-custom').hidden=false;q('#nv-custom-toggle').setAttribute('aria-expanded','true');}render();});q(i<8?'#nv-neutrals':s[0].endsWith('_solid')?'#nv-solids':'#nv-bold').append(b);});
felts.forEach(name=>{const o=document.createElement('option');o.value=name;o.textContent=name;q('#nv-felt').append(o);const b=document.createElement('button');b.type='button';b.dataset.felt=name;b.setAttribute('aria-pressed','false');b.setAttribute('aria-label',name);const im=document.createElement('img');im.src=sampleUrl(name);im.alt='';im.width=34;im.height=34;im.loading='lazy';const label=document.createElement('span');label.textContent=name;b.append(im,label);b.addEventListener('click',()=>{q('#nv-felt').value=name;customize();render();});q('#nv-felts').append(b);});
function customize(){state.custom=true;photo(original.src,original.alt);q('#nv-caption').textContent=t.custom_image;}
q('#nv-custom-toggle').addEventListener('click',()=>{const opened=q('#nv-custom').hidden;q('#nv-custom').hidden=!opened;q('#nv-custom-toggle').setAttribute('aria-expanded',String(opened));if(opened){customize();render();q('#nv-body').focus();}});q('#nv-size').addEventListener('change',render);['#nv-body-detail','#nv-accent','#nv-finish','#nv-felt','#nv-notes'].forEach(s=>q(s).addEventListener('change',()=>{customize();render();}));root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{photo(b.dataset.photo,b.dataset.alt);q('#nv-caption').textContent=t.original;}));['#nv-body-detail','#nv-accent','#nv-notes'].forEach(s=>q(s).addEventListener('input',()=>{customize();render();}));
const form=q('#nv-product-form'),engine=q('.bold_options'),cartCopy=JSON.parse(q('#nv-cart-copy').textContent);
let cartBusy=false,cartSchedule=false;
function synchronize(field,value){if(!field)return false;if(field.tagName==='SELECT'&&![...field.options].some(o=>o.value===value))return false;if(field.value!==value){field.value=value;}return field.value===value;}
function syncCart(c){
 const oldOptions=q('#bcpo');if(oldOptions){oldOptions.hidden=true;oldOptions.querySelectorAll('input,select,textarea,button').forEach(el=>{el.disabled=true;});}
 const label=state.custom?'Build your own':state.look?data.labels[state.look[0]]:'';
 const notes=[state.custom&&state.look?'Starting look: '+data.labels[state.look[0]]:'',q('#nv-notes').value].filter(Boolean).join('\n');
 const values={'Preset look':label,'Felt color':c.felt,'Body finish':c.bodyDetail||c.body,'Finish sheen':c.finish,'Design notes':notes,'Accent finish':c.accent};
 let loaded=true,matched=true;
 Object.entries(values).forEach(([name,value])=>{const field=engine.querySelector('[name="properties['+name+']"]');if(!field){loaded=false;matched=false;return;}matched=synchronize(field,value)&&matched;});
 q('#nv-size-property').value=c.size;
 const variantInput=q('#nv-variant');variantInput.name='id';variantInput.value=c.variant&&!c.customRequired?c.variant.id:'';
 const complete=!!(c.size&&c.chosen&&c.felt&&c.variant&&!c.customRequired);
 const available=complete&&c.variant.available;
 const ready=!!(loaded&&matched&&available);
 root.dataset.cartFields=JSON.stringify({'Size':c.size,...values});
 root.dataset.scReady=String(loaded&&matched);root.dataset.cartReady=String(ready);
 q('.nv-review-button').disabled=!ready||cartBusy;
 if(!cartBusy)q('#nv-cart-message').textContent=!loaded?cartCopy.waiting:!complete?cartCopy.incomplete:!available?cartCopy.unavailable:cartCopy.ready;
}
async function submitSelection(event){
 event.preventDefault();event.stopImmediatePropagation();render();
 if(root.dataset.cartReady!=='true'||cartBusy)return;
 cartBusy=true;q('.nv-review-button').disabled=true;q('#nv-cart-message').textContent=cartCopy.submitting;
 try{
  const cartFormData=new FormData(form);
  root.dataset.cartSubmitted=JSON.stringify(Object.fromEntries([...cartFormData.entries()].filter(([name])=>name==='id'||name==='quantity'||name.startsWith('properties['))));
  const response=await fetch(cartCopy.addUrl,{method:'POST',body:cartFormData,headers:{Accept:'application/json'},credentials:'same-origin'});
  root.dataset.cartHttpStatus=String(response.status);
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||result.message||cartCopy.error);
  root.dataset.cartResult=JSON.stringify({id:result.variant_id||result.id,properties:result.properties,quantity:result.quantity});
  location.assign(cartCopy.cartUrl);
 }catch(error){root.dataset.cartResult=JSON.stringify({status:root.dataset.cartHttpStatus||null,error:String(error.message)});q('#nv-cart-message').textContent=cartCopy.error+' '+error.message;}
 finally{cartBusy=false;q('.nv-review-button').disabled=root.dataset.cartReady!=='true';}
}
q('#nv-body').addEventListener('change',()=>{q('#nv-body-detail').value=q('#nv-body').value===customBody?'':q('#nv-body').value;q('#nv-accent').value='';customize();render();});
form.addEventListener('submit',submitSelection,true);
q('.nv-review-button').addEventListener('click',submitSelection,true);
new MutationObserver(records=>{
 if(cartSchedule||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('#bcpo,.bold_options,input,select,textarea')||n.querySelector('#bcpo,.bold_options,input,select,textarea')))))return;
 cartSchedule=true;requestAnimationFrame(()=>{cartSchedule=false;render();});
}).observe(form,{subtree:true,childList:true});
render();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-origins-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', function(event) {
  const form = event.target.closest('[data-origins-length]');
  if (!form) return;
  event.preventDefault();
  const select = form.querySelector('select');
  const handle = select.selectedOptions[0].dataset.handle;
  const target = new URL(form.action);
  if (handle) target.pathname = target.pathname.replace(/\/$/, '') + '/' + handle;
  target.searchParams.set('sort_by', 'manual');
  const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (preview) target.searchParams.set('preview_theme_id', preview);
  target.hash = 'ms-origins-size';
  window.location.assign(target.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-resin-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.mstd__path, .ms-resin-links a');
  if (!link) return;
  const target = new URL(link.href, location.origin);
  if (target.searchParams.has('filter.p.product_type') || target.searchParams.has('filter.p.vendor')) {
    try { sessionStorage.removeItem('ms-collection-local-search:' + target.pathname); } catch (error) {}
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-side-tables-collection"] && !Shopify.designMode) return;
  try {
    
  function initSideTableSections() {
    document.querySelectorAll('[data-side-hub]').forEach(root => {
      if (!window.ModernDirectory) return;
      window.ModernDirectory.init(root, {prefix:'side', initial:false, collectionUrl:root.dataset.collectionUrl, total:Number(root.dataset.collectionTotal), sectionId:root.dataset.sideSection, pageSize:250});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSideTableSections);
  else initSideTableSections();
  document.addEventListener('shopify:section:load', initSideTableSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-site-directory"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.directoryReady) return;
    root.dataset.directoryReady = 'true';
    const input = root.querySelector('[data-directory-search]');
    const clear = root.querySelector('[data-directory-clear]');
    const status = root.querySelector('[data-directory-status]');
    const empty = root.querySelector('[data-directory-empty]');
    const productSearch = root.querySelector('[data-directory-product-search]');
    const groups = [...root.querySelectorAll('[data-directory-group]')];
    const subgroups = [...root.querySelectorAll('[data-directory-subgroup]')];
    const sections = [...root.querySelectorAll('[data-directory-section]')];
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const entries = [...root.querySelectorAll('[data-directory-entry]')].map(element => ({ element, label:normalize(element.dataset.directoryLabel), context:normalize(element.dataset.directoryContext) }));
    const mobile = window.matchMedia('(max-width:749px)');
    let savedOpen = null;
    const setLayout = () => { if (!input.value.trim()) groups.forEach(group => { group.open = !mobile.matches; }); };
    const filter = () => {
      const query = input.value.trim();
      const words = normalize(query).split(' ').filter(Boolean);
      const searching = words.length > 0;
      if (searching && !savedOpen) savedOpen = groups.map(group => group.open);
      let count = 0;
      entries.forEach(({element,label,context}) => {
        const phrase = words.join(' ');
        const labelMatch = words.every(word => label.includes(word));
        const categoryMatch = words.length === 1 ? context.includes(phrase) : context === phrase || context.endsWith(` ${phrase}`);
        element.hidden = !labelMatch && !categoryMatch;
        if (!element.hidden) count++;
      });
      subgroups.forEach(group => { group.hidden = !group.querySelector('[data-directory-entry]:not([hidden])'); });
      groups.forEach((group,index) => {
        group.hidden = !group.querySelector('[data-directory-entry]:not([hidden])');
        if (searching && !group.hidden) group.open = true;
        else if (!searching && savedOpen) group.open = savedOpen[index];
      });
      sections.forEach(section => { section.hidden = !section.querySelector('[data-directory-entry]:not([hidden])'); });
      if (!searching) savedOpen = null;
      clear.hidden = !query;
      status.hidden = !searching;
      status.textContent = searching ? (count ? root.dataset.matchLabel.replace('[count]', String(count)) : root.dataset.emptyLabel) : '';
      empty.hidden = !searching || count > 0;
      const target = new URL(root.dataset.searchUrl, window.location.origin);
      target.searchParams.set('q', window.ModernDirectory?.searchQuery(query, 'products') ?? query);
      target.searchParams.set('type', 'product');
      target.searchParams.set('options[prefix]', 'last');
      target.searchParams.set('sort_by', 'price-ascending');
      productSearch.href = target.pathname + target.search;
    };
    const reset = () => { input.value = ''; filter(); };
    setLayout();
    filter();
    root.querySelector('[data-directory-finder]').hidden = false;
    input.addEventListener('input', filter);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); reset(); }
      if (event.key === 'Enter') { event.preventDefault(); if (!empty.hidden) window.location.assign(productSearch.href); }
    });
    clear.addEventListener('click', () => { reset(); input.focus(); });
    root.querySelectorAll('.ms-sitemap-jumps a').forEach(link => link.addEventListener('click', reset));
    root.querySelector('[data-directory-top]').addEventListener('click', event => {
      event.preventDefault();
      input.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      input.focus({preventScroll:true});
    });
    mobile.addEventListener('change', setLayout);
  };
  const start = () => document.querySelectorAll('[data-site-directory]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
